import theme from './theme';
import AppBar from '../Appbar';
import Routes from '../../routes';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { StyledApp, StyledBody } from './App.style';

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <BrowserRouter>
        <StyledApp>
          <AppBar />
        </StyledApp>
        <StyledBody>
          <Routes />
        </StyledBody>
      </BrowserRouter>
    </MuiThemeProvider>
  );
}

export default App;
